import React, { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import api from "../lib/api";

// Lightweight in-memory cache so we don't re-hit /api/users/:id for every slide.
// Keyed by user_id → { founding_vendor: bool, plan: string|null }
const _cache = new Map();

export default function FoundingVendorBadge({ userId, size = "sm" }) {
  const [info, setInfo] = useState(_cache.get(userId) || null);

  useEffect(() => {
    if (!userId) return;
    if (_cache.has(userId)) {
      setInfo(_cache.get(userId));
      return;
    }
    let cancelled = false;
    api.get(`/users/${userId}`).then(({ data }) => {
      const sub = data?.subscription || {};
      const out = {
        founding_vendor: !!sub.founding_vendor,
        plan: sub.plan || null,
      };
      _cache.set(userId, out);
      if (!cancelled) setInfo(out);
    }).catch(() => { /* ignore */ });
    return () => { cancelled = true; };
  }, [userId]);

  if (!info?.founding_vendor) return null;
  const sm = size === "sm" || size === "xs";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-300 to-pink-500 text-black font-black uppercase tracking-widest ${
        sm ? "px-1.5 py-[1px] text-[8px]" : "px-2 py-0.5 text-[10px]"
      }`}
      title="Founding Vendor — joined Hidden Gem in the first 6 months"
      data-testid={`founding-badge-${userId}`}
    >
      <Crown className={sm ? "w-2 h-2" : "w-2.5 h-2.5"} /> Founding
    </span>
  );
}
